<template>
    <div ref="charts">

    </div>
</template>

<script>
  import * as echarts from 'echarts';
  export default {
    name: 'ChartsType2',
    props:{
      xData:{
        type:Array,
        default: ()=>{
          return []
        }
      },
      xIdData:{
        type:Array,
        default: ()=>{
          return []
        }
      },
      xValueData:{
        type:Array,
        default: ()=>{
          return []
        }
      },
      xLabelData:{
        type:Array,
        default: ()=>{
          return []
        }
      },

    },
    data(){
      return {
        myChart:null
      }
    },
    watch : {
      xData(){
        this.setOption()
      }
    },
    mounted(){
      this.init()
      this.setOption()
    },
    methods:{
      init(){
        const chartDom = this.$refs.charts
        this.myChart = echarts.init(chartDom);

      },
      setOption(){
        if(!this.xValueData || !this.xValueData.length){
          return
        }
        const xValueData = []
        this.xValueData.forEach((item,index)=>{
          if(index===0){
            return
          }
          const xValueItemz = {
            name: item.text,
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: item.value
          }
          xValueData.push(xValueItemz)
        })
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross', //默认为line，line直线，cross十字准星，shadow阴影
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            data: this.xLabelData
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.xData
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series:xValueData
        }
        this.myChart.setOption(option);
      }
    }
  }
</script>

<style scoped lang="less">

</style>